import { lighten, type Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const QuoteDetailsCardWrapperStyle: StyleExtend<Theme> = {
  maxWidth: { xs: '100%', md: '25.625rem' },
  width: '100%',
  height: 'fit-content',
  borderRadius: '.25rem',
  overflow: 'hidden',
  border: (theme) => ({ xs: 'none', md: `1px solid ${theme.palette.customColors.cream}` }),
  backgroundColor: (theme) => ({
    xs: theme.palette.customColors.white50,
    md: theme.palette.customColors.lightBeige,
  }),
  boxShadow: (theme) => ({
    xs: 'none',
    md: theme.customStyling.shadow.coverageDetails,
  }),
};

export const QuoteDetailsCardTopBarStyle: StyleExtend<Theme> = {
  color: (theme) => theme.palette.customColors.white50,
  background: (theme) => theme.palette.customColors.gunMetal,
  textAlign: 'center',
  padding: '.25rem 1rem',
};

export const QuoteDetailsCardHeaderStyle: StyleExtend<Theme> = {
  padding: '1.5rem',
  backgroundColor: (theme) => ({
    xs: theme.palette.customColors.lightBeige,
    md: theme.palette.customColors.white50,
  }),
};

export const QuoteDetailsCardHeaderWrapperStyle: StyleExtend<Theme> = {
  alignItems: { sx: 'start', md: 'center' },
  gap: '1rem',
};

export const QuoteDetailsCardChildrenWrapperStyle: StyleExtend<Theme> = {
  padding: { xs: '.75rem 1.5rem .5rem', md: '1.5rem 1.5rem .25rem' },
};

export const QuoteDetailsCardFooterStyle: StyleExtend<Theme> = {
  gap: '.25rem',
  padding: { xs: '.25rem 1.5rem .75rem', md: '.75rem 1.5rem 1.5rem' },
};

export const QuoteDetailsCardPrimaryActionBtnStyle: StyleExtend<Theme> = {
  flex: 1,
};

export const QuoteDetailsCardNoteStyle: StyleExtend<Theme> = {
  backgroundColor: (theme) => ({
    xs: lighten(`${theme.palette.customColors.copper}`, 0.8),
    md: lighten(`${theme.palette.customColors.copper}`, 0.95),
  }),
  color: (theme) => theme.palette.customColors.copper,
  padding: '.25rem .5rem',
  borderRadius: '.25rem',
  margin: 0,
  textAlign: 'center',
};

export const QuoteDetailsCardCostDetailsStyle: StyleExtend<Theme> = {
  flexDirection: 'row',
  alignItems: 'end',
  gap: '.5rem',
  color: (theme) => theme.palette.customColors.gunMetal,

  'span:last-of-type': {
    mb: '.25rem',
  },
};

export const QuoteDetailsCardStickyBarStyle: StyleExtend<Theme> = {
  background: 'none',
  marginTop: (theme) => theme.customStyling.appBar.height,
  backgroundColor: (theme) => theme.palette.customColors.lightBeige,
  boxShadow: (theme) => theme.customStyling.shadow.quoteDetailsCard,
  zIndex: (theme) => theme.zIndex.appBar - 1,
};
